import { Instance, Promize, Table } from '@siposdani87/sui-js';
import { app } from '../app';
import { GroupService } from '@services/groupService';
import { LanguageService } from '@services/languageService';
import { UserService } from '@services/userService';
import { initTable } from '@utils/collectionSetup';
import { DashboardController } from './dashboardController';

export class GroupsIndexController extends DashboardController {
    static readonly inject = [
        'instances',
        'groupService',
        'userService',
        'languageService',
    ] as const;

    organizationId!: string;
    groupsTable!: Table;

    constructor(
        instances: Instance,
        private groupService: GroupService,
        private userService: UserService,
        private languageService: LanguageService,
    ) {
        super(instances);
    }

    protected override _initLayout(): void {
        this.organizationId = this.state.getParam('organizationId');

        this._initToolbarButtons();
        this._initFilterForm();

        this._drawContent();
    }

    protected override _drawContent(): Promize | boolean {
        this._initGroupTable();
        return true;
    }

    private _initGroupTable(): void {
        this.groupsTable = initTable(
            this.groupsTable,
            this.dom,
            '.groups-table',
            this.groupService,
            {
                entityKey: 'groups',
                fetchData: (params) =>
                    this.groupService.getAllByOrganization(
                        this.organizationId,
                        params,
                    ),
                extraParams: (params) => params.set('query', this.query),
            },
            [
                {
                    style: () => {
                        return [
                            'edit',
                            this.languageService.translate('buttons.edit'),
                            false,
                            !this.userService.hasAccessByOrganization(
                                this.organizationId,
                                'groups_write',
                            ),
                        ];
                    },
                    click: (group) => {
                        this.groupService.editDialog(group).then(() => {
                            this._drawContent();
                        });
                    },
                },
            ],
        )!;
    }

    private _initToolbarButtons(): void {
        this.helper.fabButton('.btn-groups-new', this.dom, () => {
            this.groupService
                .newDialogByOrganization(this.organizationId)
                .then(() => {
                    this._drawContent();
                });
        });

        this.helper.iconButton('.btn-organizations-show', this.dom, () => {
            this.state.goBack('organizations.show', {
                organizationId: this.organizationId,
            });
        });
    }
}

export const groupsIndexController = app.controller(
    'groupsIndexController',
    GroupsIndexController,
);
